import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { SharedModule } from './../shared/shared.module';
import { AgencyListComponent } from './agency-list/agency-list.component';
import { DashboardService } from './shared/dashboard.service';

@NgModule({
  imports: [
    CommonModule,
    DashboardRoutingModule,
    SharedModule
  ],
  declarations: [
  	DashboardComponent,
  	AgencyListComponent
  ],
  providers: [DashboardService],
  exports : [DashboardComponent]
})
export class DashboardModule { }



// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/dashboard/dashboard.module.ts